import React from "react";

import { Skeleton, Card, Row, Col, Avatar, List } from "antd";

const DiSkeletonCards = () => {
   
  const placeholderArray = Array.from({ length: 10 });

  return (
    <Row gutter={[16, 16]}>
      {placeholderArray.map((_, index) => (
        <Col key={index} xs={24} sm={12} md={8} lg={6}>
          <Card bordered={false} className="di-skeleton-card">
            <Skeleton loading={true} active avatar>
              <List.Item.Meta
                title={<a href="#">Titolo Placeholder</a>}
                description="Descrizione della card in attesa dei dati."
              />
              <p>Contenuto della card in caricamento...</p>
            </Skeleton>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default DiSkeletonCards;
